import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'table', 'text' ];

	connect() {
        if(this.hasTableTarget && this.hasTextTarget) {
            this.setAnchorsOnTitles();
        }
    }

    setAnchorsOnTitles() {
        const headers = this.textTarget.querySelectorAll('h1, h2, h3, h4, h5, h6');
        var contentHeaders = [];
        
        // Filter headers so only the WYSIWYG content headers will be added
        headers.forEach( (header) => {
            if(header.classList.length == 0) {
                contentHeaders.push(header);
            }
        });

        var counter = 1;

        contentHeaders.forEach( (header) => {

            this.addHeaderToList(header, counter);
            
            if(header.previousElementSibling) {
                if (header.previousElementSibling.classList.contains('anchor')) {
                    counter++;
                    return;
                }
            }

            const listItem = document.createElement("a");
            listItem.setAttribute('id', 'header-' + counter);
            listItem.classList.add('anchor');
            header.parentNode.insertBefore(listItem, header);

            counter++;
        });
    }

    addHeaderToList(header, counter) {
        const listItem = document.createElement("li");
        const link = document.createElement("a");
        link.href = '#header-' + counter;
        link.classList.add('hover:underline');
        link.innerHTML = header.innerHTML;
        listItem.appendChild(link);

        //const link = '<li><a href="header-' + counter + '">' + header.innerHTML + '</a></li>';
        this.tableTarget.append(listItem)
    }
}
